module.exports = __webpack_public_path__ + "static/1-559ef14d4eb863e48b5cbafe38c0791b.jpg";